// extracted by mini-css-extract-plugin
export default {"container":"_4zUSN","loader":"_7kRZV","heading":"Mpm8-"};